module.exports = __webpack_public_path__ + "media/ebba1-1600x1600-70CQ.069310b0.webm";